import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {NewsTabModel} from "../news.tab-model";
import {CompetitionNewsPageLinkModel} from "../../../../../containers/competition-container/pages/news-page/models/competition-news-page.link-model";

export class CompetitionNewsPageTabModel extends NewsTabModel {
  @computed get linkModel(): CompetitionNewsPageLinkModel {
    const linkModel: CompetitionNewsPageLinkModel = new CompetitionNewsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.news
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_news';
  }
}
